function n(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e === void 0 ? e : e != null && e.valueOf ? e.valueOf() : e != null && e.toString ? e.toString() : e;
}
function u(e, t) {
  return e == t ? !0 : Object.keys(e).length !== Object.keys(t).length ? !1 : Object.keys(e).every((r) => n(e[r]) === n(t[r]));
}
export {
  u as shallowEquals
};
